import AdminHsExplorePrograms from './component'
import { connect } from 'react-redux'
import { navigationEvent } from 'layers/navigation/store/operations'

const mapDispatchToProps = {
  navigationEvent,
}

export default connect(null, mapDispatchToProps)(AdminHsExplorePrograms)
